'use-client'

import { atomWithQuery } from 'jotai-tanstack-query'
import { type PublicArticle, sdk } from '../../../payload'
import { getQueryClient } from '../queryClient'

export const latestResearchAtom = atomWithQuery<PublicArticle[]>(
	() => ({
		queryKey: ['latestResearchAtom:home', { limit: 10 }],
		staleTime: 60_000,
		gcTime: 5 * 60_000,
		queryFn: async () => {
			const res = await sdk.find({
				collection: 'articles',
				limit: 3,
				sort: '-publishAt',
				where: {
					and: [
						{ status: { equals: 'published' } },
						{ publishAt: { less_than_equal: new Date().toISOString() } },
					],
				},
				select: {
					id: true,
					title: true,
					slug: true,
					excerpt: true,
					publishAt: true,
					accessLevel: true,
				},
			})
			return res?.docs
		},
	}),
	getQueryClient,
)
